var path = 'src/app/account/change-password/change-password.html';
var html = "<div page-wrapper> <h1 class=page-header>Change Password</h1> <p>Change your RaDaR password.</p> <div change-password-component user=user></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/account/change-password/change-password.html
 ** module id = 12
 ** module chunks = 0
 **/